import { useEffect } from "react";
import Transactions from "../../../Components/PaymentLedger/Transactions/Transactions";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Page_Transaction = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const adminWalletId = params.get("walletId");

  const wallet = useSelector(
    (state) => state?.paymentSlice?.walletAccountActive,
  );

  // Only redirect when visited directly (not from WalletTable admin flow)
  useEffect(() => {
    if (!adminWalletId && !wallet?.id) {
      navigate(-1);
    }
  }, [adminWalletId, wallet?.id, navigate]);

  // Pass adminWalletId only — Transactions internally falls back to wallet?.id
  // for the regular user flow and uses the session-based API
  return <Transactions walletId={adminWalletId} />;
};

export default Page_Transaction;
